export default __webpack_public_path__ + "static/media/lunch.0eac7bf0.jpg";